import { useEffect, useState } from 'react';

export default function useWindowSizeModel() {
  const getWindowSize = () => ({
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
  });

  const mobileLimit = 1200;

  const [isMobile, setIsMobile] = useState(
    getWindowSize().innerWidth < mobileLimit,
  );
  const [clientHeight, setClientHeight] = useState<number>(
    getWindowSize().innerHeight || 0,
  );

  const handleResize = () => {
    setIsMobile(getWindowSize().innerWidth < mobileLimit);
    setClientHeight(getWindowSize().innerHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return {
    isMobile,
    clientHeight,
  };
}
